<template>
  <component :is="currentStepType" />
</template>
<script>
import { mapGetters } from 'vuex'
import Simpleselect from './steps/simpleselect'
import Dimension from './steps/dimension'
import DimensionTable from './steps/dimensionTable'
import DimensionGarage from './steps/dimensionGarage'
import Conditional from './steps/conditional'
import Color from './steps/color'
import Quantity from './steps/quantity'
import Zusammen from './steps/zusammen'
import Simpletext from './steps/simpletext'
import Backside from './steps/backside'
import MontageStep from './steps/montageStep'

export default {
  components: {
    Simpleselect,
    Dimension,
    Color,
    conditional: Conditional,
    Quantity,
    dimension_table: DimensionTable,
    dimension_garage: DimensionGarage,
    Zusammen,
    Simpletext,
    Backside,
    montage_step: MontageStep
  },
  computed: {
    ...mapGetters({
      currentStep: 'configurator/currentStep'
    }),
    currentStepType () {
      return this.currentStep.type
    }
  }
}
</script>
